module.exports = __webpack_public_path__ + "static/media/fa-solid-900.bacbaa42.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/styles/webfonts/fa-solid-900.ttf
// module id = 304
// module chunks = 0